module.exports = __webpack_public_path__ + "img/logo_dy2.f4a6d6e8.png";